var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('toggle');
export var ToggleDefaultProps = {
  isOn: false,
  isHalfOn: false,
  onClick: function () {},
  isOnColor: 'primary',
  isHalfOnColor: 'primaryLighter',
  isOffColor: 'line'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n  "], ["\n    cursor: pointer;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n  "])), theme.FONT_SIZE(12)),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(13))
});
var TrackStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 16px;\n    cursor: pointer;\n    width: 32px;\n    border-radius: 14px;\n    position: relative;\n    display: flex;\n    padding: 3px;\n    transition: all 0.3s;\n    ", "\n\n    ", "\n  "], ["\n    height: 16px;\n    cursor: pointer;\n    width: 32px;\n    border-radius: 14px;\n    position: relative;\n    display: flex;\n    padding: 3px;\n    transition: all 0.3s;\n    ", "\n\n    ", "\n  "])), function (props) {
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n\n      &:hover {\n        filter: brightness(110%);\n      }\n    "], ["\n      background-color: ", ";\n\n      &:hover {\n        filter: brightness(110%);\n      }\n    "])), theme.COLOR(props.isOn ? props.isOnColor : props.isHalfOn ? props.isHalfOnColor : props.isOffColor));
  }, function (props) {
    return props.isOn && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
var SwitchStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    box-sizing: content-box;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    border-radius: 14px;\n    left: 4px;\n    font-size: 0;\n    background: #FFF;\n    transition: all 0.3s;\n\n    ", "\n\n    ", "\n\n  "], ["\n    box-sizing: content-box;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    border-radius: 14px;\n    left: 4px;\n    font-size: 0;\n    background: #FFF;\n    transition: all 0.3s;\n\n    ", "\n\n    ", "\n\n  "])), function (props) {
    return props.isOn && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      left: 18px;\n    "], ["\n      left: 18px;\n    "])));
  }, function (props) {
    return props.isHalfOn && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      left: 10.5px;\n    "], ["\n      left: 10.5px;\n    "])));
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-size: 1.0em;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n    ", "\n  "], ["\n    font-size: 1.0em;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n    ", "\n  "])), theme.COLOR('primary'), function (props) {
    return !props.isActive && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('text-subtle'));
  })
});
var OffLabelStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    margin-right: ", ";\n  "], ["\n    ", ";\n    margin-right: ", ";\n  "])), LabelStyles, theme.UNIT(2))
});
var OnLabelStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n  "])), LabelStyles, theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Switch: styled.span.attrs(cls.attr('switch'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SwitchStyles),
  Track: styled.div.attrs(cls.attr('track'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TrackStyles),
  OffLabel: styled.span.attrs(cls.attr('off-label'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), OffLabelStyles),
  OnLabel: styled.span.attrs(cls.attr('on-label'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), OnLabelStyles)
};
export var Toggle = function (props) {
  var className = props.className,
    isOn = props.isOn,
    isHalfOn = props.isHalfOn,
    onClick = props.onClick,
    offLabel = props.offLabel,
    onLabel = props.onLabel,
    isOffColor = props.isOffColor,
    isOnColor = props.isOnColor,
    isHalfOnColor = props.isHalfOnColor;
  return React.createElement(My.Container, {
    onClick: onClick,
    className: className
  }, offLabel && React.createElement(My.OffLabel, {
    isActive: !isOn
  }, offLabel), React.createElement(My.Track, {
    isOn: isOn,
    isHalfOn: isHalfOn,
    isOffColor: isOffColor,
    isOnColor: isOnColor,
    isHalfOnColor: isHalfOnColor
  }, React.createElement(My.Switch, {
    isHalfOn: isHalfOn,
    isOn: isOn
  })), onLabel && React.createElement(My.OnLabel, {
    isActive: isOn
  }, onLabel));
};
Toggle.defaultProps = ToggleDefaultProps;
Toggle.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;